import { scrollToBottom, scrollToTop } from "../../scripts/scrollUtils";

import WebDevNavImg from '../images/PortfolioNav/WebDevNavImg.jpg';
import OpenSourceNavImg from '../images/PortfolioNav/OpenSourceNavImg.png';
import AutomotiveNavImg from '../images/PortfolioNav/AutomotiveNavImg.jpg';
import PhotographyNavImg from '../images/PortfolioNav/PhotographyNavImg.png';

// Non-sub-routes
export const PRIMARY_ROUTES = [
  {'route': '/about_me', 'desc': 'Navigates to about me section. A brief introduction into who I am.'},
  {'route': '/games', 'desc': 'Navigates to a showcase of the games, I\'ve made.'},
  {'route': '/portfolio', 'desc': 'Navigates to portfolio projects from various areas of expertise.'},
];

// Routes not visible in the autocomplete menu
export const HIDDEN_ROUTES = [
  {'route': '/', 'desc': ''},
  {'route': '/dev', 'desc': ''},
  {'route': '/dev/sudoku', 'desc': ''},  
  {'route': '/commission', 'desc': ''},
  {'route': '/statistics', 'desc': ''},
];

// Routes that have no navigation to the rest of the website
export const DETACHED_ROUTES = [
  '/statistics',
]

// Routes displayed in the top nav
export const TOP_NAV_ROUTES = [
  {'route': '/portfolio', 'desc': 'Navigates to portfolio projects from various areas of expertise.'},
  {'route': '/games', 'desc': 'Navigates to a showcase of the games, I\'ve made.'}
];

// These routes will be brought into focus on page load if active
export const SCROLLABLE_ROUTES = [
  '',
  '/about_me',
  '/games/sudoku',
  '/games/maze',
  '/portfolio',
  '/portfolio/automotive',
  '/portfolio/open_source',
  '/portfolio/photography',
  '/portfolio/web',
];

export const PORTFOLIO_SECTIONS = [
  {'route': '/about_me', 'desc': 'Navigates to about me section. A brief introduction into who I am.'},
  {'route': '/portfolio', 'desc': 'Navigates to portfolio projects from various areas of expertise.'},
  {'route': '/portfolio/automotive', 'desc': 'Navigates to my car related projects.'},
  {'route': '/portfolio/open_source', 'desc': 'Navigates to my notable open-source contributions.'},
  {'route': '/portfolio/photography', 'desc': 'Navigates to some of my favorite shots.'},
  {'route': '/portfolio/web', 'desc': 'Navigates to some web projects I\'ve worked on.'},
];

export const PORTFOLIO_HERO_SECTIONS = [
  {'route': '/web', 'desc': 'Navigates to some web projects I\'ve worked on.',  'img': WebDevNavImg, 'imgAlt': 'Code'},
  {'route': '/open_source', 'desc': 'Navigates to my notable open-source contributions.', 'img': OpenSourceNavImg, 'imgAlt': 'Unlocked lock'},
  {'route': '/automotive', 'desc': 'Navigates to my car related projects.', 'img': AutomotiveNavImg, 'imgAlt': 'Check engine light'},
  {'route': '/photography', 'desc': 'Navigates to some of my favorite shots.', 'img': PhotographyNavImg, 'imgAlt': 'Camera'}
]

export const GAMES_SECTIONS = [
  {'route': '/games', 'desc': 'Navigates to a showcase of the games, I\'ve made.'},
  {'route': '/games/maze', 'desc': 'Navigates to maze generation and solving section of games page.'},
  {'route': '/games/sudoku', 'desc': 'Navigates to playable game of sudoku in 4x4, 9x9, or 16x16 variants.'},
];

// Paths are like navigation, and will change pages and scroll to section
export const paths = [
  ...GAMES_SECTIONS,
  ...PORTFOLIO_SECTIONS,
].sort((path1, path2) => path1.route.localeCompare(path2.route));

// Methods allow you to interact with the page. This means they are path specific
export const methods = [
  
];

// Commands are like methods, but they are global
export const COMMANDS = [
  {'route': 'top', 'desc': 'Scroll to top of page.'},
  {'route': 'bottom', 'desc': 'Scroll to bottom of page.'},
];

export const commandFunctions = {
  'top': scrollToTop,
  'bottom': scrollToBottom
}

// Routes to clear after execution/navigation
export const CLEAR_AFTER_EXE = {
  '/': true,
  '/about_me': true,
  ...Object.fromEntries(COMMANDS.map((command) => [command.route, true]))
}

export const ROUTE_DESCRIPTIONS = {
  
}

// All routes
const allRoutes = [...paths, ...methods, ...COMMANDS];
export default allRoutes;